import  {post}  from '../washtraxClient';

  const login = (data) => {
    return post(`/user/login`,data);
  };
export default {
  login,
};